<template>
<div class="content" v-if="dataConfig">
  <section class="no-client-selected" v-if="isClientSpecific && !currentClient">
    Izaberite klijenta
  </section>
  <section v-else class="content-table">
    <ScDataTableReports v-if="columns.length && currentData" :data="currentData" :minWidth="minWidth" :columns="shownColumns" v-model:checkedRows="checkedRows" :search="search" v-model:order="order" :dataConfig="dataConfig" @reload="reload" />
    <DataPager :pages="totalPages" v-model="currentPage" />
  </section>
</div>
</template>

<script>
import api from '@/Util/api';
import localizations from '@/Mixins/localizations';
export default {
  mixins: [localizations],
  props: ["params", "index", "active"],
  data: ()=>({
    currentPage: 0,
    perPage: 50,
    minWidth: 1200,
    columns: [],
    data: [],
    count: 0,
    order: null,
    search: {},
    checkedRows: [],
    checkedValues: [],
    localizations: {},
    selectionShown: false,
  }),
  computed: {
    shownColumns() {
      return (this.columns || []).filter(item=>item.name!="klijent.title");
    },
    isClientSpecific() {
      return !!this.columns.find(item=>item.name=="klijent.title");
    },
    currentClient() {
      return this.stores.auth.currentClient;
    },
    dataConfig() {
      return this.stores.config.config?.data?.[this.params.type];
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.params.type] ?? {};
    },
    currentData() {
      return this.data.slice();
//       return this.data.slice(this.currentPage*this.perPage, (this.currentPage+1)*this.perPage);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.count/this.perPage));
    },
    filter() {
      var filter=[];
      if (this.stores.auth.currentClient && this.columns.find(item=>item.name=="klijent.title")) {
        filter.push(["klijent", "=", this.stores.auth.currentClient.uuid]);
      }
      if (this.fieldDesc?.children) {
        filter.push(["parent", "IS NULL"]);
      }
      for(var field in this.search) {
        var value=this.search[field];
        if (!value)
          continue;
        if (typeof(value)=="string") {
          if (this.params.type=="Product" && field=="title") {
            filter.push([
              "OR",
              [field, "LIKE", `%${value}%`],
//               ["children.title", "LIKE", `%${value}%`]
            ]);
          } else
            filter.push([field, "LIKE", `%${value}%`]);
        }
      }
      return filter;
    },
    fields() {
      if (!this.dataConfig?.columns)
        return null;
      var fields=["archived", "id", "uuid", ...this.makeFields(this.dataConfig.columns.map(item=>item.name))];

      if (this.fieldDesc?.children) {
        // include at least 3 levels of children
        fields.push("children{"+fields.join(",")+
          ",children{"+fields.join(",")+
            ",children{"+fields.join(",")+
        "}}}");
      }
      return '{'+fields.join(",")+'}';
    },
  },
  watch: {
    checkedRows: {
      handler() {
        var newList=[];
        for(var uuid of this.checkedRows) {
          var found=false;
          for(var checkedItem of this.checkedValues) {
            if (checkedItem.uuid==uuid) {
              newList.push(checkedItem);
              found=true;
              break;
            }
          }
          if (!found) {
            for(var item of this.data) {
              if (item.uuid==uuid)
                newList.push(item);
              for(var subitem of item.children || []) {
                if (subitem.uuid==uuid)
                  newList.push(subitem);
              }
            }
          }
        }
        this.checkedValues=newList;
      }, deep: true,
    },
    fieldDesc: {
      handler() {
        this.columns=[
          {name: "checkbox", label: "Checkbox", width: "40px", fixed: true},
          ...this.dataConfig.columns.map(item=>({
            width: "10%",
            ...(this.fieldDesc[item.name] || {}),
            ...item,
          })),
          {
            name: "actions",
            labelComponent: "ReportNewActions",
            labelProps: { newLink: this.createLink({uuid: api.nullUuid})},
            width: "120px", fixed: true,
            contentComponent: "DataListActions"
          },
        ];
      }, immediate: true, deep: true,
    },
    filter: {
      handler() {
        clearTimeout(this.loadTimeout)
        this.loadTimeout=setTimeout(()=>{
          this.currentPage=0;
          this.loadData();
        }, 10);
      }, deep: true, immediate: true,
    },
    order: {
      handler() {
        clearTimeout(this.loadTimeout)
        this.loadTimeout=setTimeout(()=>{
          this.currentPage=0;
          this.loadData();
        }, 1);
      },
    },
    localizations: {
      handler() {
        clearTimeout(this.loadTimeout)
        this.loadTimeout=setTimeout(()=>{
          this.currentPage=0;
          this.loadData();
        }, 1);
      }, deep: true,
    },
    active: {
      handler() {
        if (this.active)
          this.loadData();
      },
    },
    currentPage: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    actionAvailable(action) {
      if (action=="makeSeparateProducts") {
        return this.checkedValues.length && !this.checkedValues.filter(item=>!item.parent).length;
      }
      if (action=="joinProducts") {
        return this.checkedValues.length>1 && !this.checkedValues.filter(item=>item.parent).length && !this.checkedValues.filter(item=>item.children?.length).length;
      }
      return false;
    },
    async doSelectionAction(action) {
      if (action=="makeSeparateProducts") {
        await api.action("Product", "new", "makeSeparate", {ids: this.checkedRows});
        this.checkedRows=[];
      }
      if (action=="joinProducts") {
        await api.action("Product", "new", "join", {ids: this.checkedRows});
        this.checkedRows=[];
      }
      await this.loadData();
    },
    makeFields(list) {
      var fields=[];
      for(var field of list || []) {
        var firstPart=(field || "").split(".")[0];
        if (fields.indexOf(firstPart)==-1)
          fields.push(firstPart);
      }
      for(var fieldIndex in fields || []) {
        var field=fields[fieldIndex];
        var subFields=list.filter(item=>item.startsWith(field+".")).map(item=>item.substring(field.length+1));
        if (subFields.length)
          subFields.push("uuid");
        if (subFields.length)
          fields[fieldIndex]+="{"+this.makeFields(subFields).join(",")+"}";
      }
      return fields;
    },
    createLink(item) {
      return {
        name: "page",
        params: {
          path: [...this.params.path.substring(1).split("/"), item.uuid],
        }
      }
    },
    createDocumentLink(item) {
      return "/api/files/"+item.document?.filename; // TODO
    },
    createLinkChild(item) {
      if (!this.fieldDesc.children)
        return;
      return {
        name: "page",
        params: {
          path: [...this.params.path.substring(1).split("/"), api.nullUuid],
        },
        query: {parent: item.uuid},
      }
    },
    itemMap(item) {
      item.link=this.createDocumentLink(item);
      item.linkParams=this.createLink(item);
      item.linkParamsChild=this.createLinkChild(item);
      item.actions={component: 'DataActions'};
      for(var citem of item.children || []) {
        this.itemMap(citem);
        citem.parent=item;
//         citem.linkParams=this.createLink(citem);
//         citem.actions={component: 'DataActions'};
      }
      return item;
    },
    async loadData() {
//       this.data=[];
      var order=null;
      if (this.order && this.order[0]=="+")
        order=[this.order.substring(1)+":ASC"];
      else if (this.order && this.order[0]=="-")
        order=[this.order.substring(1)+":DESC"];
      var result=(await api.list(this.params.type, this.filter, this.fields, order, this.perPage, this.currentPage*this.perPage, true, this.normalizedLocalizations));
      this.data=result.items.map(item=>{
        return this.itemMap(item);
      });
      this.count=result.count;
    },
    reload() {
      this.loadData();
    },
  },
  created() {
    var title=this.dataConfig?.plural || this.params.type;
    this.stackIndex=this.stores.page.pushPage(title, this.params.path, this.index);
    this.pageLink=this.stores.page.stack[this.stackIndex];
    // this.loadData();
  },
  unmounted() {
    this.stores.page.popPage(this.pageLink);
  },
}
</script>
